import React, { useState } from "react";
import ReportWizardPart1 from "./ReportWizardPart1";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import toast, { Toaster } from "react-hot-toast";
import { generateReportChunk } from "../../controllers/APIController";
import { useNavigate } from "react-router-dom";

/**
 * CreateReportWizard Component
 * Multi-step wizard for creating new ESG reports
 * Handles report creation workflow and data collection
 * @returns {JSX.Element} Report creation wizard interface
 */
const CreateReportWizard = () => {
  // Navigation hook
  const navigate = useNavigate();

  // Wizard state
  const [currentPage, setCurrentPage] = useState(0);
  const [reportData, setReportData] = useState({
    Name: "",
    "Fiscal Year": "",
    Description: "",
    TemplateIndex: null,
    frameworkId: null,
  });

  /**
   * Handle report submission
   * Generates report chunk and navigates back to reports list
   */
  const handleSubmit = () => {
    const uploadData = {
      name: reportData?.Name,
      description: reportData?.Description,
      framework: reportData?.frameworkId,
    };
    
    generateReportChunk(uploadData);
    toast.success("Report is generating, it takes some time.");
    
    navigate(-1);
  };

  return (
    <BreadCrumbsPage>
      <Toaster position="top-center" />
      <div>
        <div className="flex flex-col w-full mx-auto">
          <div className="mt-8">
            <ReportWizardPart1
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              DataList={reportData}
              setDataList={setReportData}
              onSubmitHandler={handleSubmit}
            />
          </div>
        </div>
      </div>
    </BreadCrumbsPage>
  );
};

export default CreateReportWizard;
